module.exports = __webpack_public_path__ + "assets/img/82@3x.4a2363fd.png";